module.exports = __webpack_public_path__ + "static/14-2b90cb9ac0934d8cf67970244fb582f7.jpg";